import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
            <BooleanInput source="isBriefManyProducts" label={t('admin.isBriefManyProducts')}/>
        </EditGuesser>
    )
}

export default Edit
